import React, {useMemo} from 'react';
import {Flex, Image, Select} from "antd";
import {AssetDto} from "./data/types";
import {useQuery} from "react-query";
import axios, {AxiosResponse} from "axios";

export const AdminImageChooser: React.FC<{category: AssetDto['category'], value?: any, onChange?: () => void}> = ({category, value, onChange}) => {

    const {data: allAssets} = useQuery(
        'admin-assets',
        () => axios.get<object, AxiosResponse<AssetDto[]>>(`/api/admin/assets`)
            .then(r => r.data)
    );

    const assets = useMemo<AssetDto[]>(() => (allAssets || []).filter(asset => asset.category === category), [allAssets]);

    return (
        <Select
            value={value}
            onChange={onChange}
            showSearch
            filterOption={(input, option) =>
                ((option?.label) as string ?? '').toLowerCase().includes(input.toLowerCase())
            }
        >
            {assets.map(asset => (
                <Select.Option key={asset.id} value={asset.id} label={asset.name}>
                    <Flex align="space-between">
                        <Image src={asset.url} height={32} width={32} preview={false} style={{marginRight: 10}}/>
                        <div style={{marginLeft: 10}}>{asset.name}</div>
                    </Flex>
                </Select.Option>
            ))}
        </Select>
    );
}